<template>
  <div>
    <JoinWrapper page-type="cart">
      <div class="" data-detail="done_detail">
        <div class="cart_progress">
          <div class="progress_box">
            <p class="cell">
              <span class="fn_mont">{{
                $t('views.cart.ordersuccessful.9202')
              }}</span>
              {{ $t('views.cart.ordersuccessful.2585') }}
            </p>
          </div>
          <div class="c_icon ico_progress_arrow"></div>
          <div class="progress_box">
            <p class="cell">
              <span class="fn_mont">{{
                $t('views.cart.ordersuccessful.1806')
              }}</span>
              결제하기
            </p>
          </div>
          <div class="c_icon ico_progress_arrow"></div>
          <div class="progress_box active">
            <p class="cell">
              <span class="fn_mont">{{
                $t('views.cart.ordersuccessful.4736')
              }}</span>
              결제완료
            </p>
          </div>
        </div>

        <div v-if="isGift" class="wrap">
          <div class="box_title">
            <h2 class="done_tit">
              결제가 완료되었습니다!
              <span class="order_num">주문번호 000-000-000-0000</span>
            </h2>
          </div>

          <div class="done_images">
            <img src="@/assets/images/order_result.png" alt="선물" />
          </div>
          <div class="box_title">
            <h2 class="done_tit style">
              구매하신 도서는 내서재에서<br />
              확인하실 수 있습니다.
            </h2>
          </div>
          <div class="item_wrap">
            <h2>주문상품</h2>
            <div class="flex_wrap">
              <span>쉽게 배우는 한국의 발효음식</span>
              <span>외 1개</span>
            </div>
          </div>
          <div class="payinfo_wrap">
            <h2>결제정보</h2>
            <div class="flex_wrap both">
              <span>최종 결제 금액</span>
              <div class="money">
                <span>26,000원</span>
                <span class="naver_pay">네이버페이</span>
              </div>
            </div>
          </div>
          <div class="btn_wrap">
            <router-link :to="{ name: 'orders' }" class="payinfo_detail">
              주문내역 상세
            </router-link>
            <router-link :to="{ name: 'library_default' }" class="my_lib">
              내서재 가기
            </router-link>
          </div>
          <!-- <div class="box_title">
            <h2 class="done_tit">
              <strong>도서 선물</strong>을 <strong>완료</strong>하였습니다.
            </h2>
          </div>

          <div class="done_images">
            <img src="@/assets/images/campusbook_ico.png" alt="" />
          </div>
          <div class="box_title">
            <h2 class="done_tit">
              선물하신 도서는 입력하신<strong>이메일 주소에</strong
              ><br /><strong>쿠폰번호</strong>를 포함하여
              <strong>발송</strong>됩니다.
            </h2>
          </div>
          <div class="btn_wrap">
            <router-link :to="{ name: 'orders' }" class="box_btn">
              <span class="an_t">{{
                $t('views.cart.ordersuccessful.120')
              }}</span>
            </router-link>
            <router-link :to="{ name: 'store' }" class="box_btn dull">
              <span class="an_t">{{
                $t('views.cart.ordersuccessful.9217')
              }}</span>
            </router-link>
          </div> -->
        </div>
        <div v-else class="wrap">
          <div class="box_title">
            <h2 class="done_tit fw">
              결제가 완료되었습니다!
              <span class="order_num">주문번호 {{ buyCd }}</span>
            </h2>
          </div>

          <div class="done_images">
            <img src="@/assets/images/order_result.png" alt="선물" />
          </div>
          <div v-if="!giftData" class="box_title">
            <h2 class="done_tit style">
              구매하신 도서는 내서재에서<br />
              확인하실 수 있습니다.
            </h2>
          </div>
          <div v-if="giftData" class="receive_person">
            <h2>수령인 정보</h2>
            <div class="inner_wrap">
              <div class="">
                <span>받는 분</span>
                <span>{{ giftData.name }}</span>
              </div>
              <div class="">
                <span>휴대폰 번호</span>
                <span>{{ giftData.mobileNo }}</span>
              </div>
              <div class="">
                <span>이메일</span>
                <span>{{ giftData.email }}</span>
              </div>
            </div>
          </div>
          <div class="item_wrap">
            <h2>주문상품</h2>
            <div class="flex_wrap">
              <span class="book_name">{{ formattedOrderName }}</span>
              <span v-if="items > 1"
                >외 <b>{{ items - 1 }}</b
                >개</span
              >
            </div>
          </div>
          <div class="payinfo_wrap">
            <h2>결제정보</h2>
            <div class="flex_wrap both">
              <span>최종 결제 금액</span>
              <div class="money">
                <span class="pay_price">{{ formattedPrice }} 원</span>
                <span class="naver_pay">{{ payMethod }}</span>
              </div>
            </div>
          </div>
          <div class="btn_wrap">
            <router-link :to="{ name: 'orders' }" class="payinfo_detail">
              주문내역 상세
            </router-link>
            <router-link :to="{ name: 'library_default' }" class="my_lib">
              내서재 가기
            </router-link>
          </div>
        </div>
      </div>
    </JoinWrapper>
  </div>
</template>

<script>
import JoinWrapper from '@/components/auth/JoinWrapper.vue'
export default {
  name: 'OrderSuccessful',
  components: { JoinWrapper },
  data() {
    return {
      buyCd: this.$route.query.buyCd || 1,
      items: this.$route.query.items || 1,
      orderName: this.$route.query.orderName || 1,
      price: this.$route.query.price || 1,
      payMethod: this.$route.query.payMethod || 1,
      giftData: null
    }
  },
  computed: {
    isGift() {
      // return this.$route.params.isGift
      return this.$route.params.isGift
      // return true
    },
    formattedPrice() {
      return Number(this.price).toLocaleString()
    },
    formattedOrderName() {
      // ' 외'로 문자열을 분할하고 첫 번째 부분만 반환합니다.
      return this.orderName.split(' 외')[0]
    }
  },
  beforeMount() {
    this.giftData = JSON.parse(localStorage.getItem('giftData'))
    console.log(this.giftData)
    localStorage.removeItem('giftData')
  }
}
</script>

<style lang="scss" scoped>
.box_title {
  strong {
    font-weight: 500;
  }
  .done_tit {
    line-height: 36px;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 24px;
    color: #36a5c2;
    &.style {
      margin-bottom: 20px;
      line-height: 20px;
      font-family: 'pretendard-light';
      font-size: 17px;
      color: #a8a8a8;
    }
  }
}
.done_images {
  margin: 30px 0 5px;
  img {
    width: 150px;
  }
}
.cart_st .box_btn .an_t {
  font-size: 16px;
  line-height: 47px;
}
.order_num {
  display: block;
  line-height: 17px;
  font-size: 15px;
  color: #a8a8a8;
  font-family: 'pretendard-light';
}
.flex_wrap {
  display: flex;
  justify-content: space-between;
  border: 1px solid #a8a8a8;
  border-radius: 10px;
  padding: 25px 25px;
  &.both {
    padding: 18px 25px;
  }
  span {
    display: block;
    font-weight: 600;
    font-size: 18px;
    color: #231815;
    &.naver_pay {
      font-size: 12px;
    }
    &.book_name {
      width: 210px;
      line-height: 18px;
      overflow: hidden;
      word-break: keep-all;
    }
  }
  b {
    font-family: 'pretendard-medium';
  }
}
.receive_person {
  margin-bottom: 15px;
  h2 {
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 18px;
    color: #a8a8a8;
  }
  .inner_wrap {
    border-radius: 10px;
    padding: 25px 25px;
    border: 1px solid #a8a8a8;
    > div {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        display: block;
        font-weight: 600;
        font-size: 18px;
        color: #231815;
      }
    }
  }
}
.btn_wrap {
  display: flex;
  justify-content: space-between;
  gap: 23px;
  color: #fff;
  margin-top: 12px;
  margin-bottom: 25px;
  a {
    flex: 1;
    font-size: 16px;
    border-radius: 3px;
    padding: 12px 0;
    font-weight: 600;
    &.payinfo_detail {
      background-color: #a8a8a8;
    }
    &.my_lib {
      background-color: #36a5c2;
    }
  }
}
.box_wrap {
  width: 980px;
}
.wrap {
  min-width: 286px;
  max-width: 380px;
  margin: 0 auto;
}
.item_wrap {
  margin-bottom: 15px;
}
.item_wrap,
.payinfo_wrap {
  > h2 {
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 18px;
    color: #a8a8a8;
  }
}
.money {
  text-align: right;
  span:first-child {
    margin-bottom: 2px;
    font-family: 'pretendard-medium';
  }
}
@media (max-width: 480px) {
  .wrap {
    padding: 0 15px;
  }
  .item_wrap,
  .payinfo_wrap,
  .receive_person {
    > h2 {
      font-size: 16px;
    }
  }
  .flex_wrap {
    align-items: center;
    padding: 23px 15px;
    &.both {
      padding: 15px 15px;
    }
    span {
      font-size: 15px;
      &.naver_pay {
        font-size: 12px;
      }
    }
  }
  .receive_person .inner_wrap {
    padding: 23px 15px;
    > div span {
      font-size: 15px;
    }
  }

  .btn_wrap {
    align-items: center;
    gap: 7px;
    margin-top: 20px;
    a {
      width: 60%;
      font-size: 18px;
      padding: 17px 0;
      border-radius: 7px;
    }
  }
}
</style>
